import React, { useState } from "react";
import {
  Grid,
  scopedCssBaselineClasses,
  Stack,
  Typography,
} from "@mui/material";
import ScopeTable from "../Scope/ScopeTable";

export const ScopeDetailSection = ({
  scopeDetails,
  currentScope,
  chargePercentages,
  jrData,
  setScopeFinalTotal,
}) => {
  const scopeDetailsAccepted = scopeDetails.filter(
    (item) => item.is_accepted === 1
  );
  console.log(scopeDetailsAccepted, "scopeDetailsAccepted");
  return (
    <Grid item xs={12}>
      {scopeDetailsAccepted.map((item, i) => (
        <Stack key={i} spacing={1} direction="row">
          <Grid item sm={12} md={8}>
            <Stack>
              <Typography className="title">Work to be done:</Typography>
              <Typography
                style={{
                  width: "350px",
                  overflowWrap: "break-word",
                  wordWrap: "break-word",
                  marginBottom: 5,
                }}
              >
                {item.work_to_be_done}
              </Typography>
            </Stack>
            <Stack>
              <Typography className="title">Notes: </Typography>
              <Typography
                style={{
                  width: "350px",
                  overflowWrap: "break-word",
                  wordWrap: "break-word",
                  marginBottom: 5,
                }}
              >
                {item.notes}
              </Typography>
            </Stack>
            <Stack>
              <Typography className="title">Charges:</Typography>
              <Grid item xs={12} marginTop="1em">
                <ScopeTable
                  lines={item?.scopeLines}
                  amount={item?.scope_amount}
                  chargePercentages={
                    jrData.is_send_to_market === 1 || jrData.send_market === 1
                      ? chargePercentages.marketPercentages
                      : chargePercentages.crmPercentages
                  }
                  setScopeFinalTotal={setScopeFinalTotal}
                />
                <hr style={{ marginTop: "1em" }} />
              </Grid>
            </Stack>
          </Grid>
        </Stack>
      ))}
    </Grid>
  );
};

export const ScopeSection = ({
  scopeDetails,
  handleScopeAgreementOpen,
  currentScope,
  chargePercentages,
  jrData,
}) => {
  const [scopeFinalTotal, setScopeFinalTotal] = useState("");
  return (
    <>
      {scopeDetails !== "" && scopeDetails.length > 0 && (
        <Grid container spacing={1}>
          {/* <Grid item xs={12}>
            <Stack spacing={1} direction="row">
              <Typography className="title">
                Service Agreement :{" "}
                <FilePdfTwoTone
                  className="icon-size"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleScopeAgreementOpen(
                      true,
                      scopeDetails,
                      scopeFinalTotal
                    );
                  }}
                />
              </Typography>
            </Stack>
          </Grid> */}
          <Grid item xs={12}>
            <ScopeDetailSection
              scopeDetails={scopeDetails}
              currentScope={currentScope}
              chargePercentages={chargePercentages}
              jrData={jrData}
              setScopeFinalTotal={setScopeFinalTotal}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
};
